import {configureStore, isRejected } from '@reduxjs/toolkit';
import {combineReducers} from 'redux';
import {apiSlice} from './api/apiSlice';
import {setLogout, userReducer} from './slices/userSlice';
import {setupListeners} from '@reduxjs/toolkit/query/react';
import type { MiddlewareAPI, Middleware } from '@reduxjs/toolkit'
import {messageType, showMessages} from "../helpers/message";

const reducers = combineReducers({
    user: userReducer,
    [apiSlice.reducerPath]: apiSlice.reducer
});

const rootReducer = (state: any, action: any) => {
    return reducers(state, action);
};

// If the request returns a 401 dispatch the set logout reducer.
const rtkQueryAuthenticationError: Middleware =
    (api: MiddlewareAPI) => (next) => (action) => {
        if (isRejected(action)) {
            // On failed login do not redirect to log out screen.
            if (action.payload?.data?.error_code === 4010) {
                return next(action)
            } else if (action.payload?.status === 401) {
                showMessages("Your session has expired. Please log in.", messageType.error);
                store.dispatch(setLogout());
                return;
            }
        }
        return next(action);
    };

const middlewares: Middleware[] = [rtkQueryAuthenticationError];

export const store = configureStore({
    reducer: rootReducer,
    devTools: process.env.NODE_ENV !== "production",
    middleware: getDefaultMiddleware => [
        ...getDefaultMiddleware({
            serializableCheck: false
        }).concat(apiSlice.middleware),
        ...middlewares,
    ]
});

export function safeGetStore() {
    return store.getState();
}

// Set up listeners for automatic caching behavior.
setupListeners(store.dispatch);

// Infer the `RootState` and `AppDispatch` types from the store itself.
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
